export default [
    {
        title: "Dashboard",
        modules: {
            title: "Dashboard",
            route: "/"
        }
    },
    {
        title: "Donor",
        modules:
        {
            title: "Donor",
            route: "/donor"
        }
    },
    {
        title: "Employees",
        modules: {
            title: "Employees",
            route: "/employees"
        }
    },
    {
        title: "Salary Scale Record",
        modules: {
            title: "Salary Scale Record",
            route: "/salary-scale-record"
        }
    },
    {
        title: "Timesheet",
        modules: {
            title: "Timesheet",
            route: "/timesheets"
        }
    },
    {
        title: "Overtime Request",
        modules:
        {
            title: "Overtime Request",
            route: "/overtime-request"
        }

    },
    {
        title: "Leave Request",
        modules:
        {
            title: "Leave Request",
            route: "/leaves"
        }

    },
    {
        title: "Payroll",
        modules:
        {
            title: "Payroll",
            route: "/payrolls"
        }

    },
    {
        title: "Performance",
        modules:
        {
            title: "PDD",
            route: "/performance/pdd"
        }
    },
    {
        title: "Performance",
        modules:
        {
            title: "PIP",
            route: "/performance/pip"
        }
    },
    {
        title: "Performance",
        modules:
        {
            title: "Setting",
            route: "/performance/performance-module"
        }
    },
    {
        title: "Reports",
        modules:
        {
            title: "Leave Report",
            route: "/reports/leaves"
        },

    },
    {
        title: "Reports",
        modules:
        {
            title: "Payroll Report",
            route: "/reports/payroll"
        }

    },
    {
        title: "Settings",
        modules:
        {
            title: "General",
            route: "/setting"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Department",
            route: "/setting/department"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Team",
            route: "/setting/team"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Role",
            route: "/setting/role"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Job Level",
            route: "/setting/job-level"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Job Grade",
            route: "/setting/job-grade"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Visa Type",
            route: "/setting/visa-type"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Passport Type",
            route: "/setting/passport-type"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Nationality",
            route: "/setting/nationality"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Overtime Type",
            route: "/setting/overtime-type"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Leave Type",
            route: "/setting/leave-type"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Holiday",
            route: "/setting/public-holiday"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Payroll Items",
            route: "/setting/payroll-item"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Salary Tax Rate",
            route: "/setting/salary-tax-rate"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Pension Fund",
            route: "/setting/pension-fund"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "NSSF",
            route: "/setting/nssf"
        }
    },
    {
        title: "Settings",
        modules:
        {
            title: "Seniority & Severance Pay",
            route: "/setting/seniority-severance"
        }
    },
];